<div class="modal-header d-flex justify-content-between">
  <span class="fs-4 fw-600">{{ detailTitle }}</span>
  <button type="button" class="close btn btn-sm btn-white m-r-1" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  @switch (detailType) {
    @case ('coverage') {
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead class="fixed-header">
            <tr>
              <th>Cobertura</th>
              <th class="text-center">Total Asegurados</th>
              <th class="text-center">Titulares</th>
              <th class="text-center">Cargas</th>
              <th class="text-center">Jubilados</th>
              <th class="text-center">Próx. Jubilados</th>
              <th class="text-center">Cargos</th>
            </tr>
          </thead>
          <tbody>
            @for (c of data.byCoverage; track c.coverageId) {
              <tr>
                <td>{{ c.coverageName }}</td>
                <td class="text-center">{{ c.count }}</td>
                <td class="text-center">{{ c.holders }}</td>
                <td class="text-center">{{ c.dependents }}</td>
                <td class="text-center">{{ c.turning65 }}</td>
                <td class="text-center">{{ c.turning65During }}</td>
                <td class="text-center">{{ c.cargos }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="7" class="text-center text-muted py-3">Sin registros</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @case ('campus') {
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead class="fixed-header">
            <tr>
              <th>Campus</th>
              <th class="text-center">Titulares</th>
            </tr>
          </thead>
          <tbody>
            @for (c of data.holdersByCampus; track c.campusId) {
              <tr>
                <td>{{ c.campusName }}</td>
                <td class="text-center">{{ c.count }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="2" class="text-center text-muted py-3">Sin registros</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @case ('turning65') {
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead class="fixed-header">
            <tr>
              <th class="text-center">N°</th>
              <th>Nombre Completo</th>
              <th>Fecha de Nacimiento</th>
              <th class="text-center">Edad Actual</th>
              <th>Póliza</th>
              <th>Entidad</th>
              <th>Grupo</th>
              <th class="text-center">Capital</th>
            </tr>
          </thead>
          <tbody>
            @for (p of data.turning65Detail; track $index) {
              <tr>
                <td class="text-center">{{ $index + 1 }}</td>
                <td>{{ p.fullName }}</td>
                <td>{{ p.birthdate | date:'dd/MM/yyyy': 'UTC' }}</td>
                <td class="text-center">{{ p.currentAge }}</td>
                <td>{{ p.policyCode }}</td>
                <td>{{ p.entityName }}</td>
                <td>{{ p.groupName }}</td>
                <td class="text-center">{{ p.capital | number }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="8" class="text-center text-muted py-3">Sin registros</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @case ('turning65During') {
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead class="fixed-header">
            <tr>
              <th class="text-center">N°</th>
              <th>Nombre Completo</th>
              <th>Fecha de Nacimiento</th>
              <th class="text-center">Edad Actual</th>
              <th>Póliza</th>
              <th>Entidad</th>
              <th>Grupo</th>
              <th class="text-center">Capital</th>
            </tr>
          </thead>
          <tbody>
            @for (p of data.turning65DuringDetail; track $index) {
              <tr>
                <td class="text-center">{{ $index + 1 }}</td>
                <td>{{ p.fullName }}</td>
                <td>{{ p.birthdate | date:'dd/MM/yyyy': 'UTC' }}</td>
                <td class="text-center">{{ p.currentAge }}</td>
                <td>{{ p.policyCode }}</td>
                <td>{{ p.entityName }}</td>
                <td>{{ p.groupName }}</td>
                <td class="text-center">{{ p.capital | number }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="8" class="text-center text-muted py-3">Sin registros</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @case ('cargos') {
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead class="fixed-header">
            <tr>
              <th>Cobertura</th>
              <th>Cargo</th>
              <th class="text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            @for (c of data.cargosByCoverage; track $index) {
              <tr>
                <td>{{ c.coverageName }}</td>
                <td>{{ c.positionName }}</td>
                <td class="text-center">{{ c.count }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="3" class="text-center text-muted py-3">Sin registros</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Cerrar</button>
  <button type="button" class="btn btn-success" (click)="handleExport()">
    <i class="fa fa-file-excel"></i> Exportar
  </button>
</div>
